import React from 'react'
import { Input, InputNumber, Form } from 'antd'

interface AttributeFormFieldProps {
  name: string
  type: 'text' | 'string' | 'number'
  label: string
}

const AttributeFormField = ({ name, label, type }: AttributeFormFieldProps) => {
  const getField = () => {
    if (type === 'text') {
      return (
        <Input.TextArea
          autoFocus
          required
          rows={5}
          cols={80}
          data-testid='product-attribute-form-input'
        />
      )
    }

    if (type === 'string') {
      return (
        <Input
          type={type}
          required
          data-testid='product-attribute-form-input'
        />
      )
    }

    if (type === 'number') {
      return (
        <InputNumber
          type={type}
          required
          min={0}
          data-testid='product-attribute-form-input'
        />
      )
    }
  }

  return (
    <Form.Item name={['product_attributes', name]} className='_mb-0'>
      {getField()}
    </Form.Item>
  )
}

export default AttributeFormField
